import { makeAutoObservable } from 'mobx'
import { type INormalizedApiError } from 'shared/api'
import { AgentActionSendMessage } from 'entities/AgentActions'
import { RequestAttachment } from 'entities/Attachment/model/RequestAttachment'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { AgentActionMessageStore } from 'widgets/AgentActions'

export type ICategoryMessageValue = {
  message: string
  media_url: RequestAttachment[]
}

export class CategoryMessageStore {
  isAdded = false
  error = ''
  readonly model: AgentActionSendMessage
  readonly messageStore: AgentActionMessageStore

  constructor(private _rootKey: string, entities: IEntitiesStore) {
    this.model = AgentActionSendMessage.Create()
    this.messageStore = new AgentActionMessageStore(this.model, entities)
    makeAutoObservable(this)
  }

  get hasMessage() {
    return this.isAdded && (Boolean(this.model.message.trim()) || this.model.attachments.length > 0)
  }

  get paramsValue(): ICategoryMessageValue | null {
    if (!this.hasMessage) return null
    return {
      message: this.model.message,
      media_url: this.model.attachments.map((attachment) => new RequestAttachment(attachment)),
    }
  }

  init = (value: ICategoryMessageValue | null | undefined) => {
    this.model.syncOrigin({ message: value?.message ?? '', media_url: value?.media_url ?? [] })
    this.messageStore.syncMessage()
    this.isAdded = Boolean(value?.message) || (value?.media_url?.length ?? 0) > 0
    this.error = ''
  }

  add = () => {
    this.isAdded = true
  }

  remove = () => {
    this.isAdded = false
    this.model.sync('', [])
    this.messageStore.syncMessage()
    this.setError('')
  }

  setError = (value: string) => {
    this.error = value
  }

  syncApiErrors = (apiErrors: INormalizedApiError | null | undefined) => {
    const match = apiErrors?.entries().find(([key]) => key.includes(this._rootKey))
    this.setError(match?.[1]?.value ?? '')
  }

  dispose = () => {
    this.messageStore.dispose()
  }
}
